/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs */

const en_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-written listings`)
};

const ar_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوائم مكتوبة تلقائيا`)
};

const bn_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্বয়ংক্রিয় লিস্টিং`)
};

const de_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch geschriebene Listings`)
};

const es_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios redactados automáticamente`)
};

const fr_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces rédigées automatiquement`)
};

const pt_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios escritos automaticamente`)
};

const zh_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动写 listing`)
};

const tr_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatik yazılan listelemeler`)
};

const ru_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автонаписанные листинги`)
};

const pl_svc_ai_image_pod_automation_listings_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listingi pisane automatycznie`)
};

/**
* | output |
* | --- |
* | "Auto-written listings" |
*
* @param {Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_listings_title8 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Listings_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_listings_title8(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_listings_title8(inputs)
	return en_svc_ai_image_pod_automation_listings_title8(inputs)
});
export { svc_ai_image_pod_automation_listings_title8 as "svc_ai-image-pod-automation_LISTINGS_title" }